import React from 'react';
import { defineMessage, useIntl } from 'react-intl';
import { styled } from '@linaria/react';
import { useHotelRoomsFilters } from 'hooks/useHotelRoomsFilters';
import { Alert } from '@daedalus/atlas/Alert';
import { HorizontalScroll } from '@daedalus/atlas/helpers/HorizontalScroll';
import { Icon } from '@daedalus/atlas/Icon';
import { Pill } from '@daedalus/atlas/Pill';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
import { RoomsFilterKey } from '@daedalus/core/src/room/business/utils/filters';
import { filtersConfig, messages } from './constants';
const titleMessage = defineMessage({
  id: 'filterMatchesWithCount',
  defaultMessage: 'We {count, plural, =0 {found no matches} one {only found 1 match} other {only found # matches}}'
});
const ScrollWrapper = /*#__PURE__*/styled('div')({
  name: "ScrollWrapper",
  class: "s1mjsua0",
  propsAsIs: false
});
const VerticalDivider = /*#__PURE__*/styled('div')({
  name: "VerticalDivider",
  class: "v66jir9",
  propsAsIs: false
});
export const NoFilteredRoomsResults = () => {
  const {
    formatMessage
  } = useIntl();
  const {
    activeRoomsFilters: activeFilterIds,
    toggleRoomsFilter,
    setRoomsFilters
  } = useHotelRoomsFilters();
  const activeRoomsFilters = activeFilterIds.map(filterId => filtersConfig.find(({
    id
  }) => id === filterId));
  const onRoomsFilterClick = (id: RoomsFilterKey) => toggleRoomsFilter(id);
  const clearFilters = () => setRoomsFilters([]);
  return <Alert title={formatMessage(titleMessage, {
    count: 0
  })} variant="warning" dataId="noFilteredRoomsResults">
      <FormattedMessageWrapper id="adjustFiltersToSeeMoreResults" defaultMessage="To see more results, adjust your search criteria, remove some filters, or clear all." />
      <ScrollWrapper>
        <HorizontalScroll columnGap="s200" rowGap="s200">
          {activeRoomsFilters.map(filter => <Pill key={filter.id} isSelected={false} iconEnd={<Icon name={'Close'} />} onClick={() => onRoomsFilterClick(filter.id)} dataId="noFilteredRoomsResultsFilter">
              {formatMessage(messages[filter.id])}
            </Pill>)}
          <VerticalDivider />
          <Pill iconStart={<Icon name="Trash2" />} onClick={clearFilters} dataId="noFilteredRoomsResultsClearAll">
            <FormattedMessageWrapper id="clearAll" defaultMessage="Clear all" />
          </Pill>
        </HorizontalScroll>
      </ScrollWrapper>
    </Alert>;
};

require("./NoFilteredRoomsResults.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./NoFilteredRoomsResults.tsx");